import React from 'react';
import ReactDOM from 'react-dom';
import { Web3ReactProvider } from '@web3-react/core'
import reportWebVitals from './reportWebVitals';

import App from './App';

import './index.css';
import './assets/css/plugins/bootstrap.min.css';
import './assets/css/plugins/slick.css';
import './assets/css/plugins/animate.css';
import './assets/css/style.css';

import { connectors } from './connectors'

ReactDOM.render(
    <Web3ReactProvider connectors={connectors}>
        <App />
    </Web3ReactProvider>, 
    document.getElementById('root')
);
reportWebVitals();